import React, {Component} from 'react';
import Identification from '../../../Common/Identification';
import {PageContainer, PageDescription, PageTitle} from '../../../Common/PageComponents';

class UserInfoModificationIdentificationPage extends Component {
  render() {
    return (
      <PageContainer>
        <PageTitle title="회원정보 수정을 위한 본인인증" data-qa="usagePageTitle" />
        <PageDescription>
          회원정보 변경을 위해 아이핀 또는 휴대폰 인증을 통해 본인인증을 해주세요.
          <br />
          본인인증은 회원 가입시 본인과 동일한 명의로 본인인증을 진행해야 합니다.
        </PageDescription>
        <Identification nextUrl="/my-pc-bang/management/user-info-modification" />
      </PageContainer>
    );
  }
}

export default UserInfoModificationIdentificationPage;
